

export const FETCH_SCREENSAVERS_REQUEST = 'FETCH_SCREENSAVERS_REQUEST';
export const FETCH_SCREENSAVERS_SUCCESS = 'FETCH_SCREENSAVERS_SUCCESS';
export const FETCH_SCREENSAVERS_FAILURE = 'FETCH_SCREENSAVERS_FAILURE';

export const fetchScreensaversRequest = () => {
  return{
    type: FETCH_SCREENSAVERS_REQUEST
  };
};

export const fetchScreensaversSuccess = options => {
  const { screensavers } = options.acf;

  if(screensavers){
    return {
      type: FETCH_SCREENSAVERS_SUCCESS,
      screensavers
    };
  }else{
    return {
      type: FETCH_SCREENSAVERS_FAILURE,
      error
    };
  }
};
export const fetchScreensaversFailure = error => {
  return {
    type: FETCH_SCREENSAVERS_FAILURE,
    error
  };
};

export const fetchScreensavers = () => {
  return dispatch => {
    dispatch(fetchScreensaversRequest());
    return fetch(`${apiBase}/acf/v3/options/options`)
      .then(response => response.json())
      .then(json => dispatch(fetchScreensaversSuccess(json)));
  };
};
